<template>
  <div class="banner">
    <div class="video-wrap">
      <video autoplay loop class="video" muted v-on:canplay="canplay">
        <source src="../../../assets/img/mp4_3.mp4" type="video/mp4"/>
      </video>
      <div class="inner">
        <div class="text-wrap">
          <div class="tit">赢链通</div>
          <div class="des">京信云链(北京)数字科技有限公司(拟)、京信云链(雄安)数字科技有限公司(拟)由北京京融科技有限责任公司<br />和中恒益信(北京)数字科技有限公司共同组建，京融科技及团队占股60%，中恒益信科技占股40%<br />以成为国家指定的IT系统供应商打造“北京云链”和“雄安云链” 为目标，为央企、国企、上市企业、中小微企业提供供应链科技系统服务<br/> 推动地区产业供应链健康稳健发展，优化区域经济结构调整，促进区域经济的繁荣发展</div>
          <div class="des">同时充分发挥股东优势，为集团开展的供应链贸易、乡村振兴项目、医疗健康、教育等实体产提供供应链服务</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        vedioCanPlay: false,
        fixStyle: ''
      }
    },
    methods: {
      canplay(){
        this.vedioCanPlay = true;
      }
    },
  }
</script>

<style lang="less" scoped>
.banner{
  width:100vw;
  overflow: hidden;
  position: relative;
  .video-wrap{
    position: relative;
    width:100vw;
    height:80vh;
  }
  .video{
    width:100vw;
    /* height:100%; */
    position: relative;
    background:rgba(0,0,0,0.9);
  }
  .inner{
    width:100vw;
    height:100%;
    margin:0 auto;
    position: absolute;
    overflow: hidden;
    top:0;
    left:0;
    z-index:2;
    margin:0 auto;
    background: rgba(0, 0, 0, 0.6);
    .text-wrap{
      position: absolute;
      top:20%;
      left:0;
      width:100%;
      height:100%;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 600;
        font-size: 80px;
        line-height: 56px;
        text-align: center;
        color: #FFF;
        padding-top:60px;
        padding-bottom:60px;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        color: #fff;
      }
      .agin-left{
        text-align: left;
      }
    }
  }
}
@media screen and (min-width: 1920px) {
  .banner {
    .inner{
      .text-wrap{
        .tit{
          font-size:100px;
          padding-bottom:80px;
        }
        .des{
          font-size:24px;
          line-height: 44px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>